import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type TextVariant =
  | "error"
  | "header"
  | "muted"
  | "primary"
  | "secondary"
  | "small";

export const Text = ({
  children,
  className,
  truncate = false,
  variant = "primary",
}: {
  children: ReactNode;
  className?: string;
  truncate?: boolean;
  variant?: TextVariant;
}) => {
  const variantClasses: Record<TextVariant, string> = {
    error: "text-sm text-red-600",
    header: "font-semibold text-slate-700",
    muted: "text-sm text-slate-500",
    primary: "font-medium text-slate-700",
    secondary: "text-slate-700",
    small: "text-sm font-medium text-slate-700",
  };

  return (
    <p
      className={cn(variantClasses[variant], truncate && "truncate", className)}
    >
      {children}
    </p>
  );
};
